import { render, staticRenderFns } from "./muscledetails.vue?vue&type=template&id=8d90b59c&scoped=true"
import script from "./muscledetails.vue?vue&type=script&lang=js"
export * from "./muscledetails.vue?vue&type=script&lang=js"
import style0 from "./muscledetails.vue?vue&type=style&index=0&id=8d90b59c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d90b59c",
  null
  
)

export default component.exports